<template>
<div id="container" class="container datenschutz">
  <top-menu />
  <top-logo />
  <stoppuhr />
  <lautsprecher />
  <copyright />
  <div class="fullscreen_background">
    <img src="/static/assets/veranstaltungen/Hintergrund_2860.jpg" />
  </div>
  <div class="content">
    <div class="inner">
      <div class="ueberschrift">Datenschutzerklärung</div>
      <vuescrollbar tag="div" class="content_text">
      <p>  Stand  07. Juli 2018</p>
<p>&nbsp;</p>
<p>Informationen zum Datenschutz<br>
  Datenschutzhinweise der H. Hugendubel GmbH  &amp; Co. KG</p>
<p>Wir freuen uns über Ihr Interesse an unserer  Website. Der Schutz Ihrer Privatsphäre ist für uns sehr wichtig. Nachstehend informieren  wir Sie ausführlich über den Umgang mit Ihren Daten.</p>
<h2>1. Anwendungsbereich und Verantwortliche</h2>
  <p>Diese Datenschutzerklärung  informiert die Nutzer (&quot;Sie&quot;) über die Art, den Umfang und die Zwecke  der Erhebung und Verwendung personenbezogener Daten auf der Webseite&nbsp;<a href="http://www.hugidubies.de">www.hugidubies.de</a> (im Folgenden &quot;Webseite&quot;).&nbsp;<br>
  Verantwortliche Stelle für  die Webseite ist:<br>
  H. Hugendubel GmbH &amp;  Co. KG<br>
  Hilblestraße 54<br>
  80636 München<br>
  E-Mail:  service@hugendubel.de<br>
  <br>
  Tel.: 089 - 30 75 75 75<br>
    Fax: 089 - 30 75 75 30<br><br></p>
  <h2>2. Datenerfassung auf unserer Website</h2>
  <p><strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong> <br>
  Die Datenverarbeitung auf dieser Website erfolgt durch den  Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website  entnehmen.</p>
<p><strong>Wie erfassen wir Ihre Daten?</strong> <br>
  Gewisse Daten werden automatisch beim Besuch der Website durch unsere  IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser,  Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten  erfolgt automatisch, sobald Sie unsere Website betreten. </p>
<p><strong>Wofür nutzen wir Ihre Daten?</strong> <br>
  Ein Teil der Daten wird erhoben, um eine fehlerfreie  Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse  Ihres Nutzerverhaltens verwendet werden.</p>
<p><strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong> <br>
  Sie haben jederzeit das Recht unentgeltlich Auskunft über  Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu  erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder  Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema  Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen  Adresse an uns wenden. Des Weiteren steht Ihnen ein Beschwerderecht bei der  zuständigen Aufsichtsbehörde zu.</p>
<h2>3. Ihre Betroffenenrechte</h2>
<p>Unter den  angegebenen Kontaktdaten unseres Datenschutzbeauftragten können Sie jederzeit  folgende Rechte ausüben:</p>
<ul>
  <li>Auskunft über Ihre bei uns gespeicherten Daten und deren  Verarbeitung (Art. 15 DSGVO),</li>
  <li>Berichtigung unrichtiger personenbezogener Daten (Art. 16  DSGVO),</li>
  <li>Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO),</li>
  <li>Einschränkung der Datenverarbeitung, sofern wir Ihre Daten  aufgrund gesetzlicher Pflichten noch nicht löschen dürfen (Art. 18 DSGVO),</li>
  <li>Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art. 21  DSGVO) und</li>
  <li>Datenübertragbarkeit, sofern Sie in die Datenverarbeitung  eingewilligt haben oder einen Vertrag mit uns abgeschlossen haben (Art. 20  DSGVO).</li>
</ul>
<p>Sofern Sie uns eine Einwilligung  erteilt haben, können Sie diese jederzeit mit Wirkung für die Zukunft  widerrufen.<br>
  Sie können sich jederzeit mit einer Beschwerde an die für  Sie zuständige Aufsichtsbehörde wenden (Art. 77 DSGVO i.V.m. § 19 BDSG). Ihre  zuständige Aufsichtsbehörde richtet sich nach dem Bundesland Ihres Wohnsitzes,  Ihrer Arbeit oder der mutmaßlichen Verletzung. Eine Liste der Aufsichtsbehörden  (für den nichtöffentlichen Bereich) mit Anschrift finden Sie unter:&nbsp;<a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" target="_blank">https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html</a>.</p>
<p><strong>Analyse-Tools  und Tools von Drittanbietern</strong><br>
  Beim  Besuch unserer Website kann Ihr Surf-Verhalten statistisch ausgewertet werden.  Das geschieht vor allem mit Cookies und mit sogenannten Analyseprogrammen. Die  Analyse Ihres Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten  kann nicht zu Ihnen zurückverfolgt werden. Sie können dieser Analyse  widersprechen oder sie durch die Nichtbenutzung bestimmter Tools verhindern.  Detaillierte Informationen dazu finden Sie in der folgenden  Datenschutzerklärung.<br>
  Sie  können dieser Analyse widersprechen. Über die Widerspruchsmöglichkeiten werden  wir Sie in dieser Datenschutzerklärung informieren.</p>
<h2>4. Allgemeine Hinweise und  Pflichtinformationen</h2>
<h3>Datenschutz</h3>
<p>Die Betreiber dieser Seiten nehmen den Schutz  Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten  vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie  dieser Datenschutzerklärung.<br>
  Wenn Sie diese Website benutzen, werden  verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten,  mit denen Sie persönlich identifiziert werden können. Die vorliegende  Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie  nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.<br>
  Wir weisen darauf hin, dass die  Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail)  Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem  Zugriff durch Dritte ist nicht möglich.</p>
<h3>Widerruf  Ihrer Einwilligung zur Datenverarbeitung</h3>
<p>Viele Datenverarbeitungsvorgänge sind nur mit Ihrer  ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte  Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per  E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten  Datenverarbeitung bleibt vom Widerruf unberührt.</p>
<h3>Beschwerderecht  bei der zuständigen Aufsichtsbehörde</h3>
<p>Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen  ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu. Zuständige  Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der  Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen  Sitz hat. Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten  können folgendem Link entnommen werden:&nbsp;<a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" target="_blank">https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html</a>.</p>
<h3>Recht auf  Datenübertragbarkeit</h3>
<p>Sie haben das Recht, Daten, die wir auf Grundlage Ihrer  Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an  sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format  aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen  anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch  machbar ist.</p>
<h3>SSL- bzw.  TLS-Verschlüsselung</h3>
<p>Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der  Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen,  die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung.  Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des  Browsers von &ldquo;http://&rdquo; auf &ldquo;https://&rdquo; wechselt und an dem Schloss-Symbol in  Ihrer Browserzeile.<br>
  Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die  Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.</p>
<h3>Auskunft,  Sperrung, Löschung</h3>
<p>Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen  jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten  personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der  Datenverarbeitung und ggf. ein Recht auf Berichtigung, Sperrung oder Löschung  dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten  können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns  wenden.</p>
<h2>5. Datenschutzbeauftragter</h2>
<h3>Gesetzlich  vorgeschriebener Datenschutzbeauftragter</h3>
<p>Wenn Sie Fragen zum Datenschutz haben,  schreiben Sie uns bitte eine E-Mail oder wenden Sie sich direkt an die für den  Datenschutz verantwortliche Stelle:</p>
<p>H. Hugendubel GmbH &amp; Co. KG<br>
  Datenschutz<br>
  Hilblestraße 54<br>
  80636 München<br>
  E-Mail: service@hugendubel.de<br>
  <br>
  Tel.: 089 - 30 75 75 75<br>
  Fax: 089 - 30 75 75 30</p>
<h2>6. Datenerfassung auf unserer Website</h2>
<h3>Cookies</h3>
<p>Die Internetseiten verwenden teilweise so  genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten  keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver  und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner  abgelegt werden und die Ihr Browser speichert.<br>
  Die meisten der von uns verwendeten Cookies  sind so genannte &ldquo;Session-Cookies&rdquo;. Sie werden nach Ende Ihres Besuchs  automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert bis  Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim  nächsten Besuch wiederzuerkennen.<br>
  Sie können Ihren Browser so einstellen, dass  Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall  erlauben, die Annahme von Cookies für bestimmte Fälle oder generell  ausschließen sowie das automatische Löschen der Cookies beim Schließen des  Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität  dieser Website eingeschränkt sein.<br>
  Cookies, die zur Durchführung des  elektronischen Kommunikationsvorgangs oder zur Bereitstellung bestimmter, von  Ihnen erwünschter Funktionen erforderlich sind, werden auf Grundlage von Art. 6  Abs. 1 lit. f DSGVO gespeichert. Der Websitebetreiber hat ein berechtigtes  Interesse an der Speicherung von Cookies zur technisch fehlerfreien und  optimierten Bereitstellung seiner Dienste. Soweit andere Cookies (z.B. Cookies  zur Analyse Ihres Surfverhaltens) gespeichert werden, werden diese in dieser  Datenschutzerklärung gesondert behandelt.</p>
<h3>Server-Log-Dateien</h3>
<p>Der Provider der Seiten erhebt und speichert  automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser  automatisch an uns übermittelt. Dies sind:</p>
<ul>
  <li>Browsertyp und Browserversion</li>
  <li>verwendetes Betriebssystem</li>
  <li>Referrer URL</li>
  <li>Hostname des zugreifenden Rechners</li>
  <li>Uhrzeit der Serveranfrage</li>
  <li>IP-Adresse </li>
</ul>
<p>Eine Zusammenführung dieser Daten mit anderen  Datenquellen wird nicht vorgenommen.<br>
  Grundlage für die Datenverarbeitung ist Art. 6  Abs. 1 lit. f DSGVO, der die Verarbeitung von Daten zur Erfüllung eines  Vertrags oder vorvertraglicher Maßnahmen gestattet.</p>
<h3>Verarbeiten  von Daten (Kunden- und Vertragsdaten)</h3>
<p>Personenbezogene Daten über die  Inanspruchnahme unserer Internetseiten (Nutzungsdaten) erheben, verarbeiten und  nutzen wir nur, soweit dies erforderlich ist, um dem Nutzer die Inanspruchnahme  des Dienstes zu ermöglichen.</p>
<h2>7. Analyse Tools und Werbung</h2>
<h3>Google Analytics</h3>
<p>Diese Website nutzt Funktionen des  Webanalysedienstes Google Analytics. Anbieter ist die Google Inc., 1600  Amphitheatre Parkway, Mountain View, CA 94043, USA.<br>
  Google Analytics verwendet so genannte  &bdquo;Cookies&ldquo;. Das sind Textdateien, die auf Ihrem Computer gespeichert werden und  die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den  Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der  Regel an einen Server von Google in den USA übertragen und dort gespeichert.<br>
  Die Speicherung von Google-Analytics-Cookies  erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat  ein berechtigtes Interesse an der Analyse des Nutzerverhaltens, um sowohl sein  Webangebot als auch seine Werbung zu optimieren.</p>
<p><strong><u>IP Anonymisierung</u></strong><strong><u> </u></strong><br>
  Wir haben auf dieser Website die Funktion  IP-Anonymisierung aktiviert. Dadurch wird Ihre IP-Adresse von Google innerhalb  von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des  Abkommens über den Europäischen Wirtschaftsraum vor der Übermittlung in die USA  gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von  Google in den USA übertragen und dort gekürzt. Im Auftrag des Betreibers dieser  Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website  auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um  weitere mit der Websitenutzung und der Internetnutzung verbundene  Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. Die im Rahmen von  Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit  anderen Daten von Google zusammengeführt.</p>
<p><strong><u>Browser Plugin</u></strong><strong><u> </u></strong><br>
  Sie können die Speicherung der Cookies durch  eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen  Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche  Funktionen dieser Website vollumfänglich werden nutzen können. Sie können  darüber hinaus die Erfassung der durch den Cookie erzeugten und auf Ihre  Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie  die Verarbeitung dieser Daten durch Google verhindern, indem Sie das unter dem  folgenden Link verfügbare Browser-Plugin herunterladen und installieren:&nbsp;<a href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank">https://tools.google.com/dlpage/gaoptout?hl=de</a>.</p>
<p><strong><u>Widerspruch gegen Datenerfassung</u></strong><strong><u> </u></strong><br>
  Sie können die Erfassung Ihrer Daten durch  Google Analytics verhindern, indem Sie auf folgenden Link klicken. Es wird ein  Opt-Out-Cookie gesetzt, der die Erfassung Ihrer Daten bei zukünftigen Besuchen  dieser Website verhindert:&nbsp;Google  Analytics deaktivieren.<br>
  Mehr Informationen zum Umgang mit Nutzerdaten  bei Google Analytics finden Sie in der Datenschutzerklärung von Google:&nbsp;<a href="https://support.google.com/analytics/answer/6004245?hl=de" target="_blank">https://support.google.com/analytics/answer/6004245?hl=de</a>.</p>
<p><strong><u>Auftragsdatenverarbeitung</u></strong><strong><u> </u></strong><br>
  Wir haben mit Google einen Vertrag zur  Auftragsdatenverarbeitung abgeschlossen und setzen die strengen Vorgaben der  deutschen Datenschutzbehörden bei der Nutzung von Google Analytics vollständig  um.</p>
<h2>6. Plugins und Tools</h2>
<h3>Schriften /  Webfonts</h3>
<p>Die bei uns zur Darstellung der Inhalte auf  dieser Website eingesetzten Webfonts sind selbst gehostet. Beim Laden der  Schriftdateien in den Browser erfolgt daher keine Übermittlung von Daten an  externe Dienste.</p>
<h2>8. Änderung unserer Datenschutzbestimmungen</h2>
Wir behalten uns vor, diese Datenschutzerklärung  anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht  oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen,  z.B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die  neue Datenschutzerklärung.
      </vuescrollbar>
    </div>
  </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */
/* eslint no-unused-vars: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
import VueScrollBar from 'vue-perfect-scrollbar'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'datenschutz',
  data () {
    return {
      who: 'datenschutz'
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar
  },
  mounted () {
    this.$ga.page(this.$router)
  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

.datenschutz .himmel {
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: auto;
}

.datenschutz .content {
position: absolute;
    top: 318px;
    left: 330px;
    width: 80%;
    height: 500px;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
}

.datenschutz .content .inner {
  position: relative;
}

.datenschutz .content .inner .ueberschrift {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  color: white;
  font-family: FrozenMemory;
  font-size: 36px;
}

.datenschutz .content .inner .content_text {
  position: absolute;
  top: 50px;
  left: 0;
  width: 1200px;
  height: 530px;
  padding-right: 25px;  
}
*/
.datenschutz .alphabet {
  position: absolute;
  top: 264px;
  font-family: FrozenMemory;
  font-size: 36px;
  color: #5baacb;
}

.datenschutz .alphabet .available {
  color: #3287aa;
}

.datenschutz .alphabet .active {
  color: #3287aa;
  /* text-shadow: -3px 0 white, 0 3px white, 3px 0 white, 0 -3px white;
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: white;*/
  -webkit-text-stroke: 1px white;
  /* If we weren't using text-shadow, we'd set a fallback color
     and use this to set color instead
    -webkit-text-fill-color: white; */
  text-shadow: 3px 3px 0 #FFFFFF, /* Simulated effect for Firefox and Opera
       and nice enhancement for WebKit */
  -1px -1px 0 #FFFFFF, 1px -1px 0 #FFFFFF, -1px 1px 0 #FFFFFF, /*  1px  1px 0 #FFFFFF; */
}

.datenschutz .resultat_anzeige {
  position: absolute;
  top: 287px;
  right: 330px;
  width: 500px;
  height: 500px;
  font-size: 16pt;
  font-family: 'Open Sans';
  font-weight: 400;
  overflow-y: scroll;
  color: #3e3d40;
  word-spacing: 6px;
}

.row1,
.row2 {
  width: 100%;
}

.row2 {
  margin-left: 20px;
}

.resultat_anzeige h2 {
  font-family: FrozenMemory;
  font-size: 36px;
  color: #0b7fb0;
  /* text-shadow: -3px 0 white, 0 3px white, 3px 0 white, 0 -3px white; */
  -webkit-text-stroke-width: 0.5px;
  -webkit-text-stroke-color: white;
}

.datenschutz .gigi {
  position: absolute;
  top: 817px;
  left: 624px;
  height: auto;
}

.datenschutz .hui {
  position: absolute;
  top: 866px;
  left: 872px;
  height: auto;
}

.datenschutz .libero {
  position: absolute;
  top: 916px;
  left: 1538px;
  height: auto;
}

.datenschutz .dubix {
  position: absolute;
  top: 807px;
  left: 424px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Datenschutz.vue